import { render, staticRenderFns } from "./GQLUpdate.vue?vue&type=template&id=aeaf2ece"
import script from "./GQLUpdate.vue?vue&type=script&lang=js"
export * from "./GQLUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports